import { render, staticRenderFns } from "./RestaurantMealsStats.vue?vue&type=template&id=1015bea2"
import script from "./RestaurantMealsStats.vue?vue&type=script&lang=js"
export * from "./RestaurantMealsStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports